import { Divider, Text } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import { commonStyles } from '~/styles/commonStyles';

export type ITableSectionProps = {
  children?: React.ReactNode;
  action?: React.ReactNode;
};

const styles = stylex.create({
  section: {
    padding: '1rem',
    backgroundColor: colorSchemeTokens.surfaceContainerHigh,
    display: 'grid',
    gridTemplateColumns: '1fr min-content',
    alignItems: 'center',
  },
});

export const TableSection: React.FC<ITableSectionProps> = (props) => {
  const { children, action } = props;

  return (
    <>
      <Divider sx={commonStyles.colSpanFull} />
      <div {...stylex.props(commonStyles.colSpanFull, styles.section)}>
        <Text variant="title" size="sm">
          {children}
        </Text>
        {action}
      </div>
    </>
  );
};
